<script lang="ts">
	import { totalPages, searchParams, page, resetPage } from '../stores/filter';
	import { query, hits, totalHits, selectedLayout } from '../stores/filter';
	import { lqip } from '../actions/lqip';
	import ActiveFilters from './ActiveFilters.svelte';

	let { labels } = $props();

	const goto = (page: number): string => {
		const url = new URL(document.location.href);
		for (const [param, value] of $searchParams.entries()) {
			url.searchParams.set(param, value);
		}
		url.searchParams.set('page', page);
		return url.toString();
	};

	const submitHandler = (e: Event) => {
		e.preventDefault();
	};
</script>

<div class="flow search">
	<form onsubmit={submitHandler}>
		<input
			type="search"
			placeholder={labels.searchPlaceholder}
			aria-label={labels.searchPlaceholder}
			name="query"
			bind:value={$query}
		/>
		<button type="submit">
			<span class="visually-hidden">{labels.search}</span>
			<svg width="22" height="22" viewBox="0 0 24.707 24.707">
				<use xlink:href="#icon-magnifier" />
			</svg>
		</button>
	</form>

	<div class="search-options">
		<div>
			<button
				commandfor="#filter"
				command="show-modal"
				onclick={document.getElementById('filter')?.showModal()}
				aria-controls="filter"
				aria-expanded="false"
				type="button"
			>
				Filter +
			</button>
			<ActiveFilters />
		</div>
		<div>
			{#if $totalHits !== undefined}
				{$totalHits} {$totalHits === 1 ? labels.result : labels.results}
			{/if}
		</div>
		<div>
			<fieldset class="artwork-list__layout">
				<legend>{labels.gridSize}</legend>
				<div class="layout-option">
					<input
						type="radio"
						name="layout"
						bind:group={$selectedLayout}
						value="default"
						id="layout-default"
					/>
					<label class="visually-hidden" for="layout-default">Default</label>
					<svg width="18" height="18">
						<use xlink:href="#icon-layout-default" />
					</svg>
				</div>
				<div class="layout-option">
					<input
						type="radio"
						name="layout"
						bind:group={$selectedLayout}
						value="big"
						id="layout-big"
					/>
					<label class="visually-hidden" for="layout-big">Big</label>
					<svg width="18" height="18">
						<use xlink:href="#icon-layout-big" />
					</svg>
				</div>
			</fieldset>
		</div>
	</div>
</div>

<div class="artwork-list__wrapper">
	<ul role="list" class="artwork-list" data-layout={$selectedLayout}>
		{#each $hits as hit}
			<li>
				<article>
					{#if hit.image}
						<picture>
							{#each hit.image.sources as source}
								<source
									srcset={source.srcset}
									type={source.type}
									sizes={$selectedLayout === 'default' ? '200px' : '500px'}
								/>
							{/each}
							<img
								src={hit.image.url}
								width={hit.image.width}
								height={hit.image.height}
								alt={hit.image.alt || ''}
								data-landscape={hit.image.width / hit.image.height > 2}
								loading="lazy"
								use:lqip={hit.image.lqip}
							/>
						</picture>
					{:else}
						<picture>
							<img
								src="data:image/svg+xml;charset=utf-8,<svg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2016%209'%20width='16'%20height='9'><path%20fill='%23eee'%20d='M0%200H16V9H-16Z'%20/></svg>"
								width="16"
								height="9"
								alt=""
							/>
						</picture>
					{/if}
					<div>
						<p>{hit.artists.map(a => a.name).join(', ')}</p>
						<a href={hit.url}>
							{hit.title}
						</a>
					</div>
				</article>
			</li>
		{/each}
	</ul>
</div>

{#if $totalPages > 1}
	<nav class="pagination" aria-label="Search result pagination">
		<ul role="list" class=" ">
			{#each Array($totalPages) as _page, idx}
				<li>
					<a
						aria-current={$page === idx + 1 ? 'page' : null}
						href={goto(idx + 1)}>{idx + 1}</a
					>
				</li>
			{/each}
		</ul>
	</nav>
{/if}
